import { render } from "./inquiryInfo.vue?vue&type=template&id=4dd20e70&scoped=true"
import script from "./inquiryInfo.vue?vue&type=script&lang=js"
export * from "./inquiryInfo.vue?vue&type=script&lang=js"

import "./inquiryInfo.vue?vue&type=style&index=0&id=4dd20e70&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd20e70"]])

export default __exports__